﻿export enum ImageSize {
  Small = 200,
  Medium = 320,
  ExtraSmall = 100,
}
